import React, { Fragment } from 'react';
import { Segment, Button, Icon, Table, Header, Loader, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { FiltersOnStyle, HeaderCursor, IconHeader } from '../../../Professor/ProfessorInputGrades/css';
import { Redirect } from 'react-router-dom';
import CreateCommittee from './CreateCommittee';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const NoDataMessage = () => <p>Nema kreiranih komisija.</p>;

export default class CommitteePreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            allCommittee: [],
            committeeMembers: [],
            showCreateCommittee: false,
            showCommitteeInfo: false,
            loader: true,
        };
        this.closeForm = this.closeForm.bind(this);
        this.getAllCommittee = this.getAllCommittee.bind(this);
        this.deleteCommittee = this.deleteCommittee.bind(this);
    }
    componentDidMount() {
        this.getAllCommittee();
    }

    closeForm() {
        this.setState({
            showCreateCommittee: false
        });
    }
    getAllCommittee() {
        axios.get('/committee/by-org-unit')
            .then(res => {
                let allCommittee = res.data.map((el) => ({
                    ...el, committeeMembersList: el.committeeMembers.map((e) => e)
                }));
                console.log('committee:  ', allCommittee);
                this.setState({ allCommittee: allCommittee.reverse(), loader: false });
            });
    }

    deleteCommittee(committeeId) {
        axios.delete(`/committee/${committeeId}`)
            .then(res => {
                toast('Uspješno ste izbrisati komisiju.');
                this.getAllCommittee();
            }).catch(() => toast('Nije moguće izbrisati komisiju jer je zadužena za kandidate.'));
    }

    render() {
        if (this.state.showCommitteeInfo === true) {
            return <Redirect push to={{ pathname: '/ekvivalencija-ispita/komisija/detalji', state: { student: 1 } }} />;
        }
        return (
            <div>

                <h1> Komisija </h1>
                <Segment.Group raised>
                    {this.state.showCreateCommittee && <CreateCommittee getAllCommittee={this.getAllCommittee} closeForm={this.closeForm} />}


                    <Segment clearing>
                        <Header as="h3">
                            Spisak komisija
                            <Header style={IconHeader} floated="right" >
                                {/* link */}


                                {!this.state.showCreateCommittee && <Button

                                    floated="left"
                                    icon
                                    labelPosition="right"
                                    color="blue"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={() => this.setState({ showCreateCommittee: true })}
                                ><Icon className="add" />
                                    Kreiranje komisije
                                </Button>
                                }

                            </Header>
                        </Header>
                    </Segment>
                    {this.state.loader ? <Segment style={{ paddingTop: '50px' }}><Loader active inline="centered" /></Segment> : <Segment>
                        {this.state.allCommittee.length ?
                            <div>
                                <Table celled selectable compact >
                                    <Table.Header>
                                        <Table.Row >
                                            <Table.HeaderCell>Broj odluke</Table.HeaderCell>
                                            <Table.HeaderCell>Datum odluke</Table.HeaderCell>
                                            <Table.HeaderCell>Tip</Table.HeaderCell>
                                            <Table.HeaderCell>Akademska godina</Table.HeaderCell>
                                            <Table.HeaderCell>Predsjednik komisije</Table.HeaderCell>
                                            <Table.HeaderCell width={1} />

                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {this.state.allCommittee.map((el, index) =>
                                            (<Popup
                                                trigger={
                                                    <Table.Row
                                                        key={index}
                                                        style={HeaderCursor}
                                                    >
                                                        <Table.Cell
                                                            verticalAlign="middle"
                                                            onClick={(e) => {
                                                                localStorage.setItem('committeeId', el.id);
                                                                this.setState({ showCommitteeInfo: true });
                                                            }}
                                                        >
                                                            {el.decisionNumber}
                                                        </Table.Cell>
                                                        <Table.Cell
                                                            verticalAlign="middle"
                                                            onClick={(e) => {
                                                                localStorage.setItem('committeeId', el.id);
                                                                this.setState({ showCommitteeInfo: true });
                                                            }}
                                                        >
                                                            {moment(el.decisionDate).format('D. M. YYYY.')}
                                                        </Table.Cell>
                                                        <Table.Cell
                                                            verticalAlign="middle"
                                                            onClick={(e) => {
                                                                localStorage.setItem('committeeId', el.id);
                                                                this.setState({ showCommitteeInfo: true });
                                                            }}
                                                        >
                                                            {el.committeeType}
                                                        </Table.Cell>
                                                        <Table.Cell
                                                            verticalAlign="middle"
                                                            onClick={(e) => {
                                                                localStorage.setItem('committeeId', el.id);
                                                                this.setState({ showCommitteeInfo: true });
                                                            }}
                                                        >
                                                            {el.academicYear}
                                                        </Table.Cell>
                                                        <Table.Cell
                                                            verticalAlign="middle"
                                                            onClick={(e) => {
                                                                localStorage.setItem('committeeId', el.id);
                                                                this.setState({ showCommitteeInfo: true });
                                                            }}
                                                        >
                                                            {el.committeeMembers ? Object.values(el.committeeMembers).find((e) => { if (e.committeeMemberTypeKey === 'predsjednik') return Object.values(e); }) ? Object.values(el.committeeMembers).find((e) => { if (e.committeeMemberTypeKey === 'predsjednik') return Object.values(e); }).firstName + ' ' + Object.values(el.committeeMembers).find((e) => { if (e.committeeMemberTypeKey === 'predsjednik') return Object.values(e); }).lastName : '/' : '/' }
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle" textAlign="center">
                                                            <Button
                                                                color="red"
                                                                basic="true"
                                                                size="small"
                                                                circular
                                                                icon="trash alternate"
                                                                onClick={() => this.deleteCommittee(el.id)}
                                                            />
                                                        </Table.Cell>

                                                    </Table.Row>}
                                                content="Prikaz detalja komisije"
                                                hideOnScroll
                                                position="left center"
                                            />))}
                                    </Table.Body>

                                </Table>
                            </div>

                            : <NoDataMessage />
                        }
                    </Segment>}
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Comitee/CommitteePreview.js